import { createTheme } from "@mui/material";

export function lightTheme() {
  return createTheme({
    palette: {
      mode: "light",
      primary: {
        main: "#2563EB",         // Azul moderno
        light: "#60A5FA",
        dark: "#1D4ED8",
        contrastText: "#fff",
      },
      secondary: {
        main: "#22C55E",         // Verde moderno
        light: "#86EFAC",
        dark: "#15803D",
        contrastText: "#fff",
      },
      background: {
        default: "#F7F8FA",
        paper: "#FFFFFF",
      },
      text: {
        primary: "#1E293B",     // Cinza escuro (contraste)
        secondary: "#475569",   // Cinza intermediário
      },
    },
    typography: {
      allVariants: {
        color: "#1E293B",       // Texto com ótimo contraste
      },
      fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            backgroundColor: "#fff",
            borderRadius: "6px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#CBD5E1", // Cinza claro
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#2563EB",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#2563EB",
              boxShadow: "0 0 0 1px #2563EB33",
            },
          },
        },
      },
      MuiInputBase: {
        defaultProps: {
          size: "medium",
        },
      },

    },
  });
}
